module.exports = __webpack_public_path__ + "img/quizz-step-11-6.34cb50f6.jpg";